import { GenericErrorBoundary } from "./GenericErrorBoundary";
import {
  BaseErrorBoundaryProps,
  DocumentViewerContext,
  createDocumentViewerState,
} from "./types";

interface Props extends BaseErrorBoundaryProps, DocumentViewerContext {}

export function DocViewerErrorBoundary(props: Props) {
  const { children, onError, ...contextProps } = props;

  return (
    <GenericErrorBoundary
      componentName="DocViewer"
      errorBoundaryName="DocViewerErrorBoundary"
      componentType="DocumentViewer"
      title="Document Viewer Error"
      description="The document viewer encountered an error. Please reload the page to continue viewing your documents."
      buttonText="Reload Page"
      onError={onError}
      context={contextProps}
      stateData={createDocumentViewerState(contextProps)}
    >
      {children}
    </GenericErrorBoundary>
  );
}
